import { render, staticRenderFns } from "./BoldIcon.vue?vue&type=template&id=d5fe2baa&"
import script from "./BoldIcon.vue?vue&type=script&lang=js&"
export * from "./BoldIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports